export default __webpack_public_path__ + "static/media/instructions_3.a6f1cd27.png";